import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { APIUrl } from "../../constants";
import * as api from '../../tools/apiMiddleware';

export const nonLinearStore = {
    isEditableForm: programmeId => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.CanEditNonLinearForm + `/${programmeId}`;
        api.getRequest(dispatch, url, actionTypes.GET_NL_CAN_EDIT, actionTypes.GET_NL_CAN_EDIT_SUCCESS, actionTypes.GET_NL_CAN_EDIT_FAIL);

    },
    getPlatforms: (programmeId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.GetPlatforms + `/${programmeId}`;
        await api.getRequest(dispatch, url, actionTypes.GET_PLATFORMS, actionTypes.GET_PLATFORMS_SUCCESS, actionTypes.GET_PLATFORMS_FAIL);

    },
    getValidationFlag: programmeId => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.NLValidation + `/${programmeId}`;
        await api.getRequest(dispatch, url, actionTypes.GET_NL_VALIDATION, actionTypes.GET_NL_VALIDATION_SUCCESS, actionTypes.GET_NL_VALIDATION_FAIL);

    },
    validateForm: (programmeId, valid) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.NLValidation + `/${programmeId}/${valid}`;
        await api.updateRequest(dispatch, url, {}, actionTypes.UPDATE_NL_VALIDATION, actionTypes.UPDATE_NL_VALIDATION_SUCCESS, actionTypes.UPDATE_NL_VALIDATION_FAIL, valid);

        //let url2 = APIUrl + apiRoutes.NLValidation + `/${programmeId}`;
        //await api.getRequest(dispatch, url2, actionTypes.GET_NL_VALIDATION, actionTypes.GET_NL_VALIDATION_SUCCESS, actionTypes.GET_NL_VALIDATION_FAIL);

        //let url3 = APIUrl + apiRoutes.CanEditNonLinearForm + `/${programmeId}`;
        //api.getRequest(dispatch, url3, actionTypes.GET_NL_CAN_EDIT, actionTypes.GET_NL_CAN_EDIT_SUCCESS, actionTypes.GET_NL_CAN_EDIT_FAIL);

    },
    getInitData: (programmeId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.Publication + `/${programmeId}/0`;
        await api.getRequest(dispatch, url, actionTypes.NEW_PUBLICATION, actionTypes.NEW_PUBLICATION_SUCCESS, actionTypes.NEW_PUBLICATION_FAIL);


        let url1 = APIUrl + apiRoutes.Publication + '/' + programmeId;
        await api.getRequest(dispatch, url1, actionTypes.GET_PUBLICATION_LOG, actionTypes.GET_PUBLICATION_LOG_SUCCESS, actionTypes.GET_PUBLICATION_LOG_FAIL);


        let url2 = APIUrl + apiRoutes.PublicationRights + `/${programmeId}`;
        await api.getRequest(dispatch, url2, actionTypes.GET_PUBLICATION_RIGHTS, actionTypes.GET_PUBLICATION_RIGHTS_SUCCESS, actionTypes.GET_PUBLICATION_RIGHTS_FAIL);


        let url3 = APIUrl + apiRoutes.ProgrammeCategory + `/${programmeId}`;
        await api.getRequest(dispatch, url3, actionTypes.GET_PROGRAMME_CATEGORY, actionTypes.GET_PROGRAMME_CATEGORY_SUCCESS, actionTypes.GET_PROGRAMME_CATEGORY_FAIL);
    },
    addValidationMessage: (messages) => async (dispatch) => {
        await dispatch({ type: actionTypes.UPDATE_NL_VALIDATION_MESSAGE, data: messages });
    }
};

export const reducer = (state, action) => {
    state = state || {};

    switch (action.type) {
        case actionTypes.GET_NL_CAN_EDIT:
            return {
                ...state,
                isLoading: true,
                canEditForm: state.canEditForm,
                hasErrorOccured: false
            };
        case actionTypes.GET_NL_CAN_EDIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                canEditForm: action.data.canEditForm,
                hasErrorOccured: false
            };
        case actionTypes.GET_NL_CAN_EDIT_FAIL:
            return {
                ...state,
                canEditForm: state.canEditForm,
                isLoading: false,
                hasErrorOccured: true
            };
        case actionTypes.GET_PLATFORMS:
            return {
                ...state,
                isLoading: true,
                platforms: state.platforms,
                hasErrorOccured: false
            };
        case actionTypes.GET_PLATFORMS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                platforms: action.data,
                hasErrorOccured: false
            };
        case actionTypes.GET_PLATFORMS_FAIL:
            return {
                ...state,
                isLoading: false,
                platforms: state.platforms,
                hasErrorOccured: true
            };
        case actionTypes.GET_NL_VALIDATION:
            return {
                ...state,
                isLoading: true,
                isValid: state.isValid,
                hasErrorOccured: false
            };
        case actionTypes.GET_NL_VALIDATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isValid: action.data.valid,
                hasErrorOccured: false
            };
        case actionTypes.GET_NL_VALIDATION_FAIL:
            return {
                ...state,
                isValid: state.isValid,
                isLoading: false,
                hasErrorOccured: true
            };
        case actionTypes.UPDATE_NL_VALIDATION:
            return {
                ...state,
                validationResult: state.validationResult,
                validationFailed: false,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_NL_VALIDATION_SUCCESS:

            let validationFailed = false;
            let isValid = state.isValid;

            if (action.data && action.data.length > 0) {
                validationFailed = true;
                isValid = false;
            }
            else {
                isValid = !state.isValid;
            }

            return {
                ...state,
                validationResult: action.data,
                validationFailed: validationFailed,
                isValid: isValid,
                canEditForm: !isValid,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_NL_VALIDATION_FAIL:
            return {
                ...state,
                validationResult: state.validationResult,
                isLoading: false,
                hasErrorOccured: true
            };
        case actionTypes.UPDATE_NL_VALIDATION_MESSAGE:
            return {
                ...state,
                validationResult: action.data,
                validationFailed: action.data && action.data.length > 0,
                isValid: false,
                isLoading: false,
                hasErrorOccured: false
            }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/store/NonLinear/NonLinearStore.js